// TODO: fix displayStatus everywhere, remove this
(function() {
	'use strict';
	var versionNumber = navigator.appVersion;
	var startPosition = versionNumber.lastIndexOf('MSIE');
	var version = versionNumber.substr(startPosition + 5, 3);

	if (navigator.appName === 'Microsoft Internet Explorer' && version < 8.0) {
		window.displayStatus = 'block';
	} else {
		window.displayStatus = 'table-row';
	}
}());

define("legacy/ie7", function(){});

